import {
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  Tabs,
  notification,
} from 'antd';
import {
  ExclamationCircleOutlined,
  LeftOutlined,
  RightOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  FindByTpReferenceAndTpNameParams,
  ThirdPartyRequest,
  ThirdPartyResponse,
  createThirdParty,
  findByTpReferenceAndTpName,
  getThirdPartyByRRDI,
  updateThirdParty,
} from 'services/thirdParty';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { debounce, values } from 'lodash';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import Addresse from './components/Addresse';
import { AuthContext } from 'components/Auth/Auth';
import ButtonLink from 'components/theme_components/ButtonLink';
import ButtonOperation from 'components/ButtonOperation';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import GeneralData from './components/GeneralData';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Notification from 'components/theme_components/Notifications';
import Notifications from 'components/theme_components/Notifications';
import ResetButtonAction from 'components/theme_components/ResetButtonAction';
import TabPane from 'antd/es/tabs/TabPane';
import ThirdPartyParent from './components/ThirdPartyParent';
import Title from 'components/Title';
import TitlePage from 'components/theme_components/Title';
import WizardSteps from 'components/theme_components/WizardSteps';
import { getMyWizards } from 'services/workflow';
import { useForm } from 'antd/lib/form/Form';
import { useGetThirdPartyDetail } from 'pages/ThirdParty/ThirdPartyDetail/useGetThirdPartyDetail';
import { useQuery } from 'react-query';

// import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';

export type ThirdPartyDetailStepsProps = {
  tpId?: string;
  phase?: 'LEAD' | 'TP';
  taskid?: number;
  isProposalCreate?: boolean;
  isCreate?: boolean;
  onSelect?: (item: ThirdPartyResponse) => void;
  isModal?: boolean;
  onChangeTab?: () => void;
};

const TabConcession = (props: ThirdPartyDetailStepsProps) => {
  const { isInspect } = useContext(AuthContext);

  const [modalErrorDescription, setModalErrorDescription] = useState('');
  let { id, phase } = useParams<{ id: string; phase: any }>();
  const { taskid, onSelect, isModal, onChangeTab, isCreate } = props;
  const [tptype, settptype] = useState<string>('');
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [modalErrorMessage, setModalErrorMessage] = useState('');
  const [createNewTP, setCreateNewTP] = useState<any>(null);
  const [thirdPartyData, setthirdPartyData] =
    useState<ThirdPartyResponse | null>(null);
  const [loadingSearch, setLoadingSearch] = useState<boolean>(false);
  const [tpreference, setTpreference] = useState<string | null>(null);

  const [fromBuic, setFromBuic] = useState<boolean | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [tpparentcompanyid, setTpparentcompanyid] = useState<number | null>(
    null
  );

  // Nouveaux états pour la gestion des modals TM
  const [showTMCreationModal, setShowTMCreationModal] = useState(false);
  const [showTMUpdateModal, setShowTMUpdateModal] = useState(false);
  const [createdMoralThirdId, setCreatedMoralThirdId] = useState<number | null>(null);

  const location = useLocation();

  const { data: wizData } = useQuery(['getMyWizards', 'THIRDPARTY'], () =>
    getMyWizards({ entity: 'THIRDPARTY' }).then((res) => res.data)
  );

  const getId = () => {
    return props.tpId ? (props.tpId === '0' ? undefined : props.tpId) : id;
  };
  const getPhase = () => {
    return props.phase ? props.phase : phase;
  };

  id = getId() as any;
  phase = getPhase();

  const [form] = useForm();
  const navigate = useNavigate();

  // Vérifier si on revient d'une mise à jour de TM
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const fromTMUpdate = searchParams.get('fromTMUpdate') === 'true';
    
    if (fromTMUpdate) {
      setShowTMUpdateModal(true);
      // Nettoyer l'URL
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    // Removed cancel() to prevent unintended navigation when updating
  }, [onChangeTab]);

  const [current, setCurrent] = useState(id ? 0 : -1);
  const validateRRDI = (value: any) => {
    const alphanumericRegex = /^[a-zA-Z0-9]+$/;
    if (value.length !== 7 || !alphanumericRegex.test(value)) {
      Notification({
        status: 'error',
        message: 'Le RRDI doit être composé de 7 caractères alphanumériques',
        duration: 3,
        placement: 'top',
      });
      return false;
    } else {
      return true;
    }
  };
  const gettptype = (tp: any) => {
    settptype(tp);
  };

  const { data, isFetching } = useQuery(
    ['getThirdPartyByRRDI', tpreference],
    () =>
      getThirdPartyByRRDI({ rrdi: tpreference ?? '' })
        .then((response) => {
          setLoadingSearch(false);

          if (
            response.code === '200' &&
            response?.data?.generalData?.tpreference?.toUpperCase() ===
              tpreference?.toUpperCase()
          ) {
            setthirdPartyData(response?.data);
            setCreateNewTP(false);
            setFromBuic(false);
            setLoadingSearch(false);
          } else if (response.code === '202') {
            setFromBuic(true);
            setthirdPartyData(response?.data);
            setCreateNewTP(false);
            setLoadingSearch(false);
          } else if (response.code === '404') {
            setCreateNewTP(true);
            setthirdPartyData(null);
            setFromBuic(false);
            setLoadingSearch(false);
          }
        })
        .catch((response) => {
          setLoadingSearch(false);

          Notification({
            status: 'error',
            message: response.message,
            description: response.description,
            duration: 10,
            placement: 'topRight',
          });
          setCreateNewTP(false);
          setthirdPartyData(null);
        }),
    {
      enabled: tpreference != null,
    }
  );

  const next = () => {
    form.validateFields().then(() => {
      setCurrent(current + 1);
    });
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const done = () => {
    // navigate(`/thirdparty-sfs/${555}/PROPOSAL`)
  };

  const steps = [
    { stepcomcode: 'GeneralData', key: 'step1' },
    { stepcomcode: 'Address', key: 'step2' },
    // { stepcomcode: 'TpParent', key: 'step3' },
  ];

  const stepsContent = {
    step1: (
      <Spin spinning={isFetching}>
        <GeneralData form={form} required={current == 0} />
      </Spin>
    ),
    step2: <Addresse form={form} required={current == 1} />,
    // step3:
    //     <ThirdPartyParent
    //         required={current === 2}
    //         tpparentcompanyid={tpparentcompanyid}  // Pass the prop here
    //         onSelectTpParent={(tpparentcompanyid: number) => setTpparentcompanyid(tpparentcompanyid)}
    //     />
  };

  const initialSearchParams: any = {
    parentid: 0,
    role: '',
    tpfiscalid: '',
    tpname: '',
    tpreference: '',
    tpcardid: '',
    tptype: '',
    tplegalform: '',
    cityorzipcode: '',
    tpbrand: '',
    noparent: false,
  };
  const [searchParams, setSearchParams] = useState<any>(initialSearchParams);

  const searchThirdparty = debounce(async (tprefernce: string) => {
    setLoadingSearch(true);
    /**
             *  200 OK :
                    Données trouvées dans la base de données.
                202 Accepted :
                    Données trouvées dans un système externe.
                404 Not Found :
                    Données introuvables partouts
             * 
             */
  }, 1000);

  const keywordSearch = (e: any) => {
    if (e.target.value.length >= 3) {
      setLoadingSearch(true);
      setTpreference(e.target.value);
    } else {
      setthirdPartyData(null);
      setCreateNewTP(null);
    }
  };

  const { data: thirdParty, refetch } = useGetThirdPartyDetail(
    isNaN(Number(id)) ? undefined : Number(id),
    'TP'
  );
  useEffect(() => {
    if (thirdParty) {
      formSetFieldsValue(thirdParty);
      setTpparentcompanyid(thirdParty?.additionalInfo?.tpparentcompanyid);
      console.log(
        'test the selected parent company id from tabconcession  ==>',
        thirdParty?.additionalInfo.tpparentcompanyid
      );
    } else {
      form.resetFields();
    }
  }, [thirdParty]);

  const formSetFieldsValue = (thirdParty: ThirdPartyResponse) => {
    form.setFieldsValue({
      tpclass: thirdParty?.generalData?.tpclass,
      tpclasslabel: thirdParty?.generalData?.tpclasslabel,
      tpclassdate: thirdParty?.generalData?.tpclassdate,
      tprevenue: thirdParty?.generalData?.tprevenue,
      tprevenuereferenceyear: toDatePickerDate(
        thirdParty?.generalData?.tprevenuereferenceyear
      ),
      tpidentitycardcountry: thirdParty?.generalData?.tpidentitycardcountry,
      tpidentitycardexpirationdate: toDatePickerDate(
        thirdParty?.generalData?.tpidentitycardexpirationdate
      ),
      tpactivitysector: thirdParty?.generalData?.tpactivitysector,
      tpflagresident: thirdParty?.generalData?.tpflagresident,
      tpcategory: thirdParty?.generalData?.tpcategory,
      tpcompanysize: thirdParty?.generalData?.tpcompanysize,
      tpparentcompanyid: thirdParty?.additionalInfo?.tpparentcompanyid,
      tpparentcompanyname: thirdParty?.generalData?.tpparentcompanyname,
      tpfree1: thirdParty?.additionalInfo?.tpfree1,
      tpfree2: thirdParty?.additionalInfo?.tpfree2,
      tpfree3: thirdParty?.additionalInfo?.tpfree3,
      tpfree4: thirdParty?.additionalInfo?.tpfree4,
      tpfree5: thirdParty?.additionalInfo?.tpfree5,
      tpdescription: thirdParty?.additionalInfo?.tpdescription,
      tpid: thirdParty?.generalData?.tpid,
      currcode: thirdParty?.generalData?.currcode,
      tpreference: thirdParty?.generalData?.tpreference,
      tptype: thirdParty?.generalData?.tptype,
      tptypelabel: thirdParty?.generalData?.tptypelabel,
      tppaymentdelegation: thirdParty?.generalData?.tppaymentdelegation
        ? 'Oui'
        : 'Non',
      tpkycstatuslabel: thirdParty?.generalData?.tpkycstatuslabel,
      tpkycstatus: thirdParty?.generalData?.tpkycstatus,
      tpkycdate: thirdParty?.generalData?.tpkycdate?.substring(0, 10),
      tpstatuslabel: thirdParty?.generalData?.tpstatuslabel,
      tpstatusdate: thirdParty?.generalData?.tpstatusdate?.substring(0, 10),
      tpstatuslabelgeneraldata:
        thirdParty?.generalData?.tpstatuslabel +
        ' (' +
        thirdParty?.generalData?.tpstatusdate?.substring(0, 10) +
        ')',
      tpbrokerid: thirdParty?.generalData?.tpbrokerid,
      tplegalform: thirdParty?.generalData?.tplegalform,
      taxregime: thirdParty?.generalData.taxregime,
      tpname: thirdParty?.generalData?.tpname,
      tpsurname: thirdParty?.generalData?.tpsurname,
      tpmiddlename: thirdParty?.generalData?.tpmiddlename,
      tpmaidenname: thirdParty?.generalData?.tpmaidenname,
      tpmarketingname: thirdParty?.generalData?.tpmarketingname,
      tpmanagername: thirdParty?.generalData?.tpmanagername,
      tpmanagerposition: thirdParty?.generalData?.tpmanagerposition,
      tpactivity: thirdParty?.generalData?.tpactivity,
      tpbranchid: thirdParty?.generalData?.tpbranchid,
      mgid: thirdParty?.generalData?.mgid,
      lancode: thirdParty?.generalData?.lancode,
      countcode: thirdParty?.generalData?.countcode,
      tpcompanycreationdate: toDatePickerDate(
        thirdParty?.generalData?.tpcompanycreationdate
      ),
      tpflagvatexemption: thirdParty?.generalData?.tpflagvatexemption,
      tpvatexemtionenddate: toDatePickerDate(
        thirdParty?.generalData?.tpvatexemtionenddate
      ),
      tpfiscalid: thirdParty?.generalData?.tpfiscalid,
      tpfiscalcity: thirdParty?.generalData?.tpfiscalcity,
      tptaxid: thirdParty?.generalData?.tptaxid,
      tpsalutationcode: thirdParty?.generalData?.tpsalutationcode,
      tpgender: thirdParty?.generalData?.tpgender,
      tpbirthdate: toDatePickerDate(thirdParty?.generalData?.tpbirthdate),
      tpbirthcity: thirdParty?.generalData?.tpbirthcity,
      tpbirthcountry: thirdParty?.generalData?.tpbirthcountry,
      tpprofession: thirdParty?.generalData?.tpprofession,
      tpidentitycardtype: thirdParty?.generalData?.tpidentitycardtype,
      tpidentitycardid: thirdParty?.generalData?.tpidentitycardid,
      tpmaritalstatus: thirdParty?.generalData?.tpmaritalstatus,
      tpnbofchildren: thirdParty?.generalData?.tpnbofchildren,
      tpworkingctdate: toDatePickerDate(
        thirdParty?.generalData?.tpworkingctdate
      ),
      tpworkingcttype: thirdParty?.generalData?.tpworkingcttype,
      tporigin: thirdParty?.generalData?.tporigin,
      tpspecialtag: thirdParty?.generalData?.tpspecialtag,

      parentCompany: {
        tpid: thirdParty?.generalData?.tpparentcompanyid,
        tpname: thirdParty?.generalData?.tpparentcompanyidname,
        tpreference: thirdParty?.generalData?.tpparentcompanyidreference,
      },
      tptradingid: thirdParty?.generalData?.tptradingid,
      tpcompanyid: thirdParty?.generalData?.tpcompanyid,

      tpparentcompanyidreference:
        thirdParty?.generalData?.tpparentcompanyidreference,
      tpparentcompanyidname: thirdParty?.generalData?.tpparentcompanyidname,
      tpcapital: thirdParty?.generalData?.tpcapital,
      tpbrand: thirdParty?.generalData?.tpbrand,
      tpcapitalholding: Number(thirdParty?.generalData?.tpcapitalholding),
      tppoliticallyexposedperson:
        thirdParty?.generalData?.tppoliticallyexposedperson,
      tpantimoneylaunder: thirdParty?.generalData?.tpantimoneylaunder,
      tpmainadrstreet1: thirdParty?.address?.tpmainadrstreet1,
      tpmainadrstreet2: thirdParty?.address?.tpmainadrstreet2,
      tpmainadrstreet3: thirdParty?.address?.tpmainadrstreet3,
      tpmainadrcity: thirdParty?.address?.tpmainadrcity,
      tpmainadrzipcode: thirdParty?.address?.tpmainadrzipcode,
      tpmainadrregion: thirdParty?.address?.tpmainadrregion,
      tpmainadrregionglobale: thirdParty?.address?.tpmainadrregionglobale,
      tpmainadrcountry: thirdParty?.address?.tpmainadrcountry,
      tpsecadrstreet1: thirdParty?.address?.tpsecadrstreet1,
      tpsecadrstreet2: thirdParty?.address?.tpsecadrstreet2,
      tpsecadrcity: thirdParty?.address?.tpsecadrcity,
      tpsecadrzipcode: thirdParty?.address?.tpsecadrzipcode,
      tpsecadrregion: thirdParty?.address?.tpsecadrregion,
      tpsecadrcountry: thirdParty?.address?.tpsecadrcountry,
      bkaccountkeymain: thirdParty?.bankAccount?.bkaccountkey,
      bkaccountnummain: thirdParty?.bankAccount?.bkaccountnum,
      bkbranchcodemain: thirdParty?.bankAccount?.bkbranchcode,
      bkcodemain: thirdParty?.bankAccount?.bkcode,
      bktypemain: thirdParty?.bankAccount?.bktype,
      tpibanmain: thirdParty?.bankAccount?.tpiban,
      tpbicmain: thirdParty?.bankAccount?.tpbic,
      tpbanknamemain: thirdParty?.bankAccount?.tpbankname,
      tpcbtype: thirdParty?.bankAccount?.tpcbtype,
      tpcbnummain: thirdParty?.bankAccount?.tpcbnum,
      tpcbdatemain: thirdParty?.bankAccount?.tpcbdate,
      tpcbkeymain: thirdParty?.bankAccount?.tpcbkey,
      tpcbnamemain: thirdParty?.bankAccount?.tpcbname,
      tptel1: thirdParty?.contact?.tptel1,
      tptelmobile1: thirdParty?.contact?.tptelmobile1,
      tpemail1: thirdParty?.contact?.tpemail1,
      tpcontactname1: thirdParty?.contact?.tpcontactname1,
      tpcontactposition1: thirdParty?.contact?.tpcontactposition1,
      tptel2: thirdParty?.contact?.tptel2,
      tptelmobile2: thirdParty?.contact?.tptelmobile2,
      tpemail2: thirdParty?.contact?.tpemail2,
      tpcontactname2: thirdParty?.contact?.tpcontactname2,
      tpcontactposition2: thirdParty?.contact?.tpcontactposition2,
      tpsaleuserid: thirdParty?.correspondent?.tpsaleuserid,
      tpsaleusername: thirdParty?.correspondent?.tpsaleusername,
      tpsaleuserdate: thirdParty?.correspondent?.tpsaleuserdate?.substring(
        0,
        10
      ),
      tpriskuserid: thirdParty?.correspondent?.tpriskuserid,
      tpriskusername: thirdParty?.correspondent?.tpriskusername,
      tpriskuserdate: thirdParty?.correspondent?.tpriskuserdate?.substring(
        0,
        10
      ),
      tpbouserid: thirdParty?.correspondent?.tpbouserid,
      tpbousername: thirdParty?.correspondent?.tpbousername,
      tpbouserdate: thirdParty?.correspondent?.tpbouserdate?.substring(0, 10),
      tprecuserid: thirdParty?.correspondent?.tprecuserid,
      tprecusername: thirdParty?.correspondent?.tprecusername,
      tprecuserdate: thirdParty?.correspondent?.tprecuserdate?.substring(0, 10),
      tplpuserid: thirdParty?.correspondent?.tplpuserid,
      tplpusername: thirdParty?.correspondent?.tplpusername,
      tplpuserdate: thirdParty?.correspondent?.tplpuserdate?.substring(0, 10),
      tpemployer: thirdParty?.income?.tpemployer,
      tpemployeraddress: thirdParty?.income?.tpemployeraddress,
      tpemloyertel: thirdParty?.income?.tpemloyertel,
      tpmonthlyincome: thirdParty?.income?.tpmonthlyincome,
      tpothersincome: thirdParty?.income?.tpothersincome,
      tpfamilybenefits: thirdParty?.income?.tpfamilybenefits,
      tpothersexpense: thirdParty.income?.tpothersexpense,
      tpotherloan: thirdParty?.income?.tpotherloan,
      tpflagclient: thirdParty?.role?.tpflagclient,
      tpflagsupplier: thirdParty?.role?.tpflagsupplier,
      tpflagguarantor: thirdParty?.role?.tpflagguarantor,
      tproleother: thirdParty?.role?.tproleother,
      tppaymodein: thirdParty?.role?.tppaymodein,
      tppaydelayin: thirdParty?.role?.tppaydelayin,
      tppaymodeout: thirdParty?.role?.tppaymodeout,
      tppaydelayout: thirdParty?.role?.tppaydelayout,
      tplateinterestformula: thirdParty?.role?.tplateinterestformula,
      tpblocklateinterestinvoicing:
        thirdParty.role?.tpblocklateinterestinvoicing,
      tpreminderfeesformula: thirdParty?.role?.tpreminderfeesformula,
      tpblockreminderfeesinvoicing:
        thirdParty?.role?.tpblockreminderfeesinvoicing,
      tpblockrejectionfeesinvoicing:
        thirdParty?.role?.tpblockrejectionfeesinvoicing,
      tprejectionfeesformula: thirdParty?.role?.tprejectionfeesformula,

      spname: thirdParty?.spouse?.spname,
      spsurname: thirdParty?.spouse?.spsurname,
      spgender: thirdParty?.spouse?.spgender,
      spbirthdate: toDatePickerDate(thirdParty?.spouse?.spbirthdate),
      spbirthcity: thirdParty?.spouse?.spbirthcity,
      spbirthcountry: thirdParty?.spouse?.spbirthcountry,
      spmaidenname: thirdParty?.spouse?.spmaidenname,

      spsalutationcode: thirdParty?.spouse?.spsalutationcode,
      spfiscalid: thirdParty?.spouse?.spfiscalid,
      spprofession: thirdParty?.spouse?.spprofession,
      spidentitycardtype: thirdParty?.spouse?.spidentitycardtype,
      spidentitycardid: thirdParty?.spouse?.spidentitycardid,
      spemployer: thirdParty?.spouse?.spemployer,
      spemployeraddress: thirdParty?.spouse?.spemployeraddress,
      spemloyertel: thirdParty?.spouse?.spemloyertel,
      spmonthlyincome: thirdParty?.spouse?.spmonthlyincome,
      spothersincome: thirdParty?.spouse?.spothersincome,
      spothersexpense: thirdParty?.spouse?.spothersexpense,
      spotherloan: thirdParty?.spouse?.spotherloan,
      tpsalestatuslabel: thirdParty?.status?.tpsalestatuslabel,
      tpsalestatusdate: thirdParty?.status?.tpsalestatusdate?.substring(0, 10),
      tpriskstatuslabel: thirdParty?.status?.tpriskstatuslabel,
      tpriskstatusdate: thirdParty?.status?.tpriskstatusdate?.substring(0, 10),
    });
  };

  const prepareThirdPartyRequest = (values: any): any => {
    return {
      additionalInfo: {
        tpparentcompanyid: tpparentcompanyid,
        tpparentcompanyname: values?.tpparentcompanyname,
        tpfree1: values?.tpfree1,
        tpfree2: values?.tpfree2,
        tpfree3: values?.tpfree3,
        tpfree4: values?.tpfree4,
        tpfree5: values?.tpfree5,
        tpdescription: values?.tpdescription,
      },
      address: {
        tpmainadrstreet1: values?.tpmainadrstreet1,
        tpmainadrstreet2: values?.tpmainadrstreet2,
        tpmainadrstreet3: values?.tpmainadrstreet3,
        tpmainadrcity: values?.tpmainadrcity,
        tpmainadrzipcode: values?.tpmainadrzipcode,
        tpmainadrregion: values?.tpmainadrregion,
        tpmainadrregionglobale: values?.tpmainadrregionglobale,
        tpmainadrcountry: values?.tpmainadrcountry,
        tpsecadrstreet1: values?.tpsecadrstreet1,
        tpsecadrstreet2: values?.tpsecadrstreet2,
        tpsecadrcity: values?.tpsecadrcity,
        tpsecadrzipcode: values?.tpsecadrzipcode,
        tpsecadrregion: values?.tpsecadrregion,
        tpsecadrcountry: values?.tpsecadrcountry,
      },
      bankAccount: {
        bkaccountkey: values?.bkaccountkeymain,
        bkaccountnum: values?.bkaccountnummain,
        bkbranchcode: values?.bkbranchcodemain,
        bkcode: values?.bkcodemain
          ? values?.bkcodemain
          : form.getFieldValue('bkcodemain'),
        bktype: values?.bktype,
        countcode: values?.countcode,
        tpbkid: values?.tpbkid,
        currcode: values?.currcode,
        tpiban: values?.tpibanmain,
        tpbic: values?.tpbicmain,
        tpbankname: values?.tpbanknamemain,
        tpcbtype: values?.tpcbtype,
        tpcbnum: values?.tpcbnum,
        tpcbdate: values?.tpcbdate,
        tpcbkey: values?.tpcbkey,
        tpcbname: values?.tpcbname,
      },
      contact: {
        // tptel1: values?.tptel1?.replace(/\s+/g, ''),
        tptelmobile1: values?.tptelmobile1,
        tpemail1: values?.tpemail1,
        tpcontactname1: values?.tpcontactname1,
        tpcontactposition1: values?.tpcontactposition1,
        tptel2: values?.tptel2,
        tptelmobile2: values?.tptelmobile2,
        tpemail2: values?.tpemail2,
        tpcontactname2: values?.tpcontactname2,
        tpcontactposition2: values?.tpcontactposition2,
        tpcontactid: 0,
        tpid: 0,
        firstname: '',
        lastname: '',
        position: '',
        tel1: '',
        tel2: '',
        email: '',
      },
      generalData: {
        tpcompanyid: values?.tpcompanyid,
        tptradingid: values?.tptradingid,
        currcode: values?.currcode,
        tpid: values?.tpid,
        tptype: 'CONC',
        tpbrokerid: values?.tpbrokerid,
        tplegalform: values?.tplegalform,
        taxregime: values?.taxregime,
        tpname: values?.tpname,
        tpsurname: values?.tpsurname,
        tpmiddlename: values?.tpmiddlename,
        tpmaidenname: values?.tpmaidenname,
        tpflagvatexemption: values?.tpflagvatexemption,
        tpvatexemtionenddate: values?.tpvatexemtionenddate,
        tpmarketingname: values?.tpmarketingname,
        tpmanagername: values?.tpmanagername,
        tpmanagerposition: values?.tpmanagerposition,
        tpactivity: values?.tpactivity,
        tpbranchid: values?.tpbranchid,
        tpbrand: values?.tpbrand,
        tppaymentdelegation:
          values?.tppaymentdelegation === 'TRUE'
            ? true
            : values?.tppaymentdelegation === 'FALSE'
            ? false
            : values?.tppaymentdelegation,
        lancode: values?.lancode,
        countcode: values?.countcode,
        tpcompanycreationdate: values?.tpcompanycreationdate,
        tpfiscalid: values?.tpfiscalid,
        tpfiscalcity: values?.tpfiscalcity,
        tptaxid: values?.tptaxid,
        tpsalutationcode: values?.tpsalutationcode,
        tpgender: values?.tpgender,
        tpbirthdate: values?.tpbirthdate,
        tpbirthcity: values?.tpbirthcity,
        tpbirthcountry: values?.tpbirthcountry,
        tpprofession: values?.tpprofession,
        tpidentitycardtype: values?.tpidentitycardtype,
        tpidentitycardid: values?.tpidentitycardid,
        tpmaritalstatus: values?.tpmaritalstatus,
        tpnbofchildren: values?.tpnbofchildren,
        tpworkingctdate: dateToString(values?.tpworkingctdate),
        tpworkingcttype: values?.tpworkingcttype,
        tpcapital: values?.tpcapital,
        tpcapitalholding: values?.tpcapitalholding,
        tpkycstatus: values?.tpkycstatus,
        tppoliticallyexposedperson: values?.tppoliticallyexposedperson,
        tpantimoneylaunder: values?.tpantimoneylaunder,
        tporigin: values?.tporigin,
        tpspecialtag: values?.tpspecialtag,
        tpparentcompanyid: tpparentcompanyid,
        last_action: wizData?.taskidCreate,
        tpflagresident: values?.tpflagresident,
        tpcategory: values?.tpcategory,
        tpcompanysize: values?.tpcompanysize,
        tprevenue: values?.tprevenue,
        tprevenuereferenceyear: values?.tprevenuereferenceyear,
        tpidentitycardcountry: values?.tpidentitycardcountry,
        tpidentitycardexpirationdate: dateToString(
          values?.tpidentitycardexpirationdate
        ),
        tpactivitysector: values?.tpactivitysector,
        tpreference: values?.tpreference,
        // tpflagconsentmain:values?.tpflagconsentmain,
        // tpflagconsent2:values?.tpflagconsent2,
        // tpflagconsent3:values?.tpflagconsent3,
        // tpflagconsent4:values?.tpflagconsent4,
        // tpflagconsent5:values?.tpflagconsent5,
        //not found in Api ThirdParty
      },
      income: {
        tpemployer: values?.tpemployer,
        tpemployeraddress: values?.tpemployeraddress,
        tpemloyertel: values?.tpemloyertel,
        tpmonthlyincome: values?.tpmonthlyincome,
        tpothersincome: values?.tpothersincome,
        tpfamilybenefits: values?.tpfamilybenefits,
        tpothersexpense: values?.tpothersexpense,
        tpotherloan: values?.tpotherloan,
      },
      role: {
        tpreminderfeesformula: values?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          values?.tpblockreminderfeesinvoicing === undefined
            ? false
            : values?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          values?.tpblockrejectionfeesinvoicing === undefined
            ? false
            : values?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: values?.tprejectionfeesformula,

        tpflagclient: true,
        tpflagsupplier: true,
        tpflagguarantor: values?.tpflagguarantor,
        tproleother: values?.tproleother,
        tppaymodein: values?.tppaymodein,
        tppaydelayin: values?.tppaydelayin,
        tppaymodeout: values?.tppaymodeout,
        tppaydelayout: values?.tppaydelayout,
        tplateinterestformula: values?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          values?.tpblocklateinterestinvoicing === undefined
            ? false
            : values?.tpblocklateinterestinvoicing,
      },
      spouse: {
        spname: values?.spname,
        spsurname: values?.spsurname,
        spgender: values?.spgender,
        spbirthdate: dateToString(values?.spbirthdate),
        spbirthcity: values?.spbirthcity,
        spbirthcountry: values?.spbirthcountry,
        spmaidenname: values?.spmaidenname,
        spsalutationcode: values?.spsalutationcode,
        spfiscalid: values?.spfiscalid,
        spprofession: values?.spprofession,
        spidentitycardtype: values?.spidentitycardtype,
        spidentitycardid: values?.spidentitycardid,
        spemployer: values?.spemployer,
        spemployeraddress: values?.spemployeraddress,
        spemloyertel: values?.spemloyertel,
        spmonthlyincome: values?.spmonthlyincome,
        spothersincome: values?.spothersincome,
        spothersexpense: values?.spothersexpense,
        spotherloan: values?.spotherloan,
      },
    };
  };

  // Nouvelles fonctions pour gérer les modals TM
  const handleTMCreationConfirm = () => {
    setShowTMCreationModal(false);
    if (createdMoralThirdId) {
      navigate(`/thirdparty-sfs/${createdMoralThirdId}/PM/update?fromTMCreation=true`);
    }
  };

  const handleTMUpdateModalConfirm = () => {
    setShowTMUpdateModal(false);
    if (createdMoralThirdId) {
      navigate(`/thirdparty-sfs/${createdMoralThirdId}/PM`);
    }
  };

  const cancel = () => {
    if (id) {
      navigate(-1);
    } else {
      setCurrent(-1);
    }
    form.resetFields();
    setCreateNewTP(false);
    setthirdPartyData(null);
  };

  const onFinish = (e: any) => {
    const tpdData = prepareThirdPartyRequest(values);

    form
      .validateFields(e)
      .then((values) => {
        const tpdData = prepareThirdPartyRequest(values);

        let generalData = {
          ...tpdData?.generalData,
          tpbirthdate: dateToString(tpdData?.generalData?.tpbirthdate),
        };

        const dataSave = {
          ...tpdData,
          generalData: generalData,
          fromBuic: fromBuic ?? false,
        };

        if (thirdParty) {
          setIsLoading(true);
          updateThirdParty({
            ThirdPartyRequest: dataSave,
            tpid: Number(id),
          })
            .then((res) => {
              setIsLoading(false);

              if (res.code === '200') {
                Notification({
                  status: 'success',
                  message: 'Le tiers a été modifié.',
                  description: res.description,
                  duration: 3,
                  placement: 'top',
                });
                navigate(`/thirdparty-sfs/${res.data.generalData.tpid}/CONC`);
                refetch();
              } else {
                Notification({
                  status: 'error',
                  message: 'Erreur',
                  description: res.description,
                  duration: 10,
                  placement: 'top',
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
            });
        } else {
          setIsLoading(true);

          createThirdParty({ ThirdPartyRequest: dataSave })
            .then((res) => {
              console.log('Code de réponse reçu:', res.code);
              setIsLoading(false);

              if (res.code === '200') {
                Notifications({
                  status: 'success',
                  message: 'Le tiers a été crée',
                  // description: "Tiers physique cree",
                  duration: 3,
                  placement: 'top',
                });
                navigate(`/thirdparty-sfs/${res.data.generalData.tpid}/CONC`);
              } else if (res.code === '201') {
                const moralThirdId = res.data?.additionalInfo?.tpparentcompanyid || res.data?.generalData?.tpparentcompanyid;
                
                if (moralThirdId) {
                  setCreatedMoralThirdId(moralThirdId);
                  setShowTMCreationModal(true); // Afficher le premier popup
                } else {
                  console.log('ERREUR: Aucun ID de TM trouvé dans la réponse');
                  // Fallback navigation
                  navigate(`/thirdparty-sfs/${res.data.generalData.tpid}/CONC`);
                }
              } else if (res.code === '202') {
                Notifications({
                  status: 'success',
                  message: 'Le tiers a été crée',
                  description: 'Tiers physique est rataché',
                  duration: 3,
                  placement: 'top',
                });
                navigate(`/thirdparty-sfs/${res.data.generalData.tpid}/CONC`);
              } else if (res.code === '417') {
                let errorMessage = 'Erreur de validation';
                try {
                  if (res.description) {
                    const parsedDescription = JSON.parse(res.description);
                    if (
                      Array.isArray(parsedDescription) &&
                      parsedDescription.length > 0
                    ) {
                      errorMessage =
                        parsedDescription[0].message || errorMessage;
                    }
                  }
                } catch (error) {
                  errorMessage = res.description || errorMessage;
                }
                setModalErrorDescription(errorMessage);
                setErrorModalVisible(true);
                return;
              } else {
                notification.error({
                  message: res.message,
                  description: res.description,
                });
                isModal && form.resetFields();
              }
            })
            .catch((err) => {
              setIsLoading(false);
            });
        }
      })
      .catch((err) => {});
  };
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <Form
      className="home"
      layout="vertical"
      form={form}
      labelAlign="left"
      onFinish={(values) => {
        onFinish(values);
      }}
    >
      <TitlePage
        level={2}
        comcode={id ? 'UpdateTp' : 'NewTp'}
        bgColor="green"
      />

      {!id ? (
        <div className="container-stepper">
          {current == -1 ? (
            <>
              <Row justify="center" style={{ marginTop: 60 }}>
                <Col span={24}>
                  <FormInput
                    name="tpreference"
                    style={{ marginBottom: 1 }}
                    rules={[
                      {
                        validator(_, value) {
                          const alphanumericRegex = /^[a-zA-Z0-9]+$/;
                          if (
                            !value ||
                            (value.length == 7 && alphanumericRegex.test(value))
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              'Le RRDI doit être composé de 7 caractères alphanumériques'
                            )
                          );
                        },
                      },
                    ]}
                    noSpecialChars
                  >
                    <Input
                      className="ut-input-search"
                      onChange={(e) => {
                        keywordSearch(e);
                      }}
                      addonAfter={
                        <SearchOutlined
                          onClick={(e: any) => {
                            searchThirdparty;
                          }}
                        />
                      }
                    />
                  </FormInput>
                  <p
                    style={{ color: '#979393dd' }}
                    className="ut-input-search-notif mt-1"
                  >
                    <ExclamationCircleOutlined />{' '}
                    <GetLabel label="searchifexistinbuic" />{' '}
                  </p>
                </Col>
              </Row>

              {loadingSearch ? (
                <Spin spinning={loadingSearch}></Spin>
              ) : (
                <>
                  {createNewTP == true ? (
                    <Row justify="center" style={{ marginTop: 20 }}>
                      <Col span={24}>
                        <GetLabel className="mt-3" label="no_result_in_buic" />
                        <Row className="d-flex justify-between align-center">
                          <Col xs={18}>
                            <GetLabel label="createtpwiththisref" />
                          </Col>
                          <Col xs={6} className="d-flex justify-end">
                            <ResetButtonAction
                              comcode="Annuler"
                              className="mr-4 ut-reset-btn"
                            />
                            <ButtonLink
                              comcode="Valider"
                              className="ut-submit-btn"
                              type="primary"
                              onClick={() => {
                                const tpreference =
                                  form.getFieldValue('tpreference');
                                if (validateRRDI(tpreference)) {
                                  setCurrent(0);
                                }
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : thirdPartyData != null ? (
                    <Row justify="center" style={{ marginTop: 40 }}>
                      <Col span={24}>
                        <Col>
                          {fromBuic ? (
                            <GetLabel label="exist_in_buic" />
                          ) : (
                            <GetLabel label="exist_in_whs" />
                          )}
                        </Col>
                        <Card className="w-100 no-border">
                          <Row className="align-center">
                            <Col xs={18}>
                              <p className="font-size-15">
                                {thirdPartyData?.generalData?.tpreference}
                              </p>
                              <h3 className="font-size-18">
                                {thirdPartyData?.generalData?.tpname}
                              </h3>
                              <p className="font-size-15">
                                {thirdPartyData?.address?.tpmainadrcity} -{' '}
                                {thirdPartyData?.generalData?.tpbrand}
                              </p>
                            </Col>
                            <Col xs={6} className="text-right">
                              {fromBuic ? (
                                <ButtonOperation
                                  type="primary"
                                  className="ut-submit-btn"
                                  comcode="selectthirdparty"
                                  onClick={() => {
                                    if (thirdPartyData) {
                                      console.log(
                                        'thirdPartyData',
                                        thirdPartyData
                                      );
                                      formSetFieldsValue(thirdPartyData);
                                      next();
                                      setCreateNewTP(true);
                                    }
                                  }}
                                />
                              ) : (
                                <ButtonLink
                                  type="primary"
                                  className="ut-submit-btn"
                                  comcode="DisplayThirdpaty"
                                  to={`/thirdparty-sfs/${thirdPartyData?.generalData?.tpid}/CONC`}
                                />
                              )}
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  ) : (
                    ''
                  )}
                </>
              )}
            </>
          ) : (
            <div>
              <Spin spinning={isLoading || isFetching}>
                <Row>
                  <Title
                    comcode="infoToComplete"
                    level={4}
                    className="ut-updateTP-title mb-7 mt-10"
                  />
                </Row>
                <WizardSteps
                  steps={steps}
                  stepsContent={stepsContent}
                  direction="horizontal"
                  currentStep={current}
                  className="my-custom-class"
                  onNext={next}
                  onPrev={prev}
                  nextComcode="Next"
                  prevComcode={current === 0 ? 'Réinitialiser' : 'Previous'}
                  doneComcode="Done"
                  onCancel={cancel}
                  isLoading={isLoading}
                />
              </Spin>
            </div>
          )}
        </div>
      ) : (
        <div className="container-stepper">
          <Row>
            <Title
              comcode="infoToComplete"
              level={4}
              className="ut-updateTP-title mb-7 mt-10"
            />
          </Row>
          <WizardSteps
            steps={steps}
            stepsContent={stepsContent}
            direction="horizontal"
            currentStep={current}
            className="my-custom-class"
            onNext={next}
            onPrev={prev}
            nextComcode="Next"
            prevComcode={current === 0 ? 'Réinitialiser' : 'Previous'}
            doneComcode="Done"
            onCancel={cancel}
            isLoading={isLoading}
          />
        </div>
      )}

      {/* Modal existant */}
      <ConfirmModal
        visible={modalVisible}
        status="error"
        message="Le tiers physique a été automatiquement rattaché au Tiers Moral"
        description="Merci de renseigner les informations obligatoires"
        onConfirm={() => {
          navigate(
            `/thirdparty-sfs/${form.getFieldValue(
              'tpparentcompanyid'
            )}/PM/grouping`
          );
        }}
        onCancel={() => setModalVisible(false)}
        onlyConfirm
      />

      {/* Modal d'erreur existant */}
      <ConfirmModal
        visible={errorModalVisible}
        status="warning"
        message="Erreur de validation"
        description={modalErrorDescription}
        onConfirm={() => {
          setErrorModalVisible(false);
        }}
        Confirmcomcode="cancel"
        onlyConfirm
      />

      {/* Nouveau modal pour création TM */}
      <ConfirmModal
        visible={showTMCreationModal}
        status="error"
        message="Le tiers physique a été automatiquement rattaché au Tiers Moral"
        description="Merci de renseigner les informations obligatoires"
        onConfirm={handleTMCreationConfirm}
        onCancel={() => setShowTMCreationModal(false)}
        Confirmcomcode="Confirmer"
        onlyConfirm
      />

      {/* Nouveau modal pour confirmation mise à jour TM */}
      <ConfirmModal
        visible={showTMUpdateModal}
        status="success"
        message="Modifications effectuées"
        description="Les informations du tiers moral peuvent être modifié dans sa fiche"
        onConfirm={handleTMUpdateModalConfirm}
        onCancel={() => setShowTMUpdateModal(false)}
        Confirmcomcode="Confirmer"
        onlyConfirm
      />
    </Form>
  );
};

export default TabConcession;